import * as React from 'react';
import { alphaSorter } from 'vet-bones/utils';

import { dataModelItemsSelector } from 'src/selectors/dataModelItems';
import { ModelSelectItem } from 'src/selectors/modelItems';
import { replaceableModelItemsSelector } from 'src/selectors/replaceableModelItems';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const useDataModels = (
  databaseId: string,
  selectedModels: ModelSelectItem[]
) => {
  // just Data Models
  const dataModelItems = useReduxSelector(dataModelItemsSelector(databaseId));

  // both Data Models and Combo Models
  const modelItems = useReduxSelector(
    replaceableModelItemsSelector(databaseId)
  );

  return React.useMemo(() => {
    const dataModels = new Set<string>();
    const unimportableNamedGraphIris = new Set<string>();

    selectedModels.forEach((model) => {
      const modelItem = modelItems.find((item) => item.value === model.value);

      modelItem?.namedGraphIris.forEach((namedGraphIri) => {
        const item = dataModelItems.find(
          (item) => item.namedGraphIri === namedGraphIri
        );
        if (item) {
          dataModels.add(item.value);
        } else {
          unimportableNamedGraphIris.add(namedGraphIri);
        }
      });
    });
    return {
      dataModels: [...dataModels].sort(alphaSorter),
      unimportableNamedGraphIris: [...unimportableNamedGraphIris].sort(
        alphaSorter
      ),
    };
  }, [dataModelItems, modelItems, selectedModels]);
};
